import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CenteredBlockLayoutComponent } from '@exl-ng/mulo-views';
import { CommonModule } from '@angular/common';

import { ProfileStandaloneRoutingModule } from './profile-standalone-routing.module';
import { ProfileStandaloneComponent } from './profile-standalone.component';
import { ProfileModule } from '../profile.module';
import { ProfileOutputModule } from '../profile-output/profile-output.module';
import { LayoutsModule } from '../../parts/layouts/layouts.module';
import { ProfileActivationModule } from '../../profile-activation/profile-activation.module';
import { ProfileProjectsModule } from '../profile-projects/profile-projects.module';

@NgModule({
    imports: [
        ProfileStandaloneRoutingModule,
        LayoutsModule,
        TranslateModule,
        ProfileModule,
        ProfileOutputModule,
        ProfileOutputModule,
        ProfileProjectsModule,
        CommonModule,
        CenteredBlockLayoutComponent,
        ProfileActivationModule,
        ProfileStandaloneComponent,
    ],
})
export class ProfileStandaloneModule {}
